/**
 * Remembers the vault a user last acted on (request, approval, or decrypt), per browser, so
 * multi-vault dropdowns can default to it instead of alphabetical-first.
 */
const PREFIX = "tether.lastVault.";

export function touchVault(userId: string, vaultId: string): void {
  try {
    localStorage.setItem(PREFIX + userId, vaultId);
  } catch {
    /* best-effort */
  }
}

export function lastVault(userId: string): string | null {
  try {
    return localStorage.getItem(PREFIX + userId);
  } catch {
    return null;
  }
}
